import React from 'react'
import { Button } from 'src/design-system'
import { ALLOWED_TYPES } from 'src/utils/file-validation'

type UploadAttachmentsButtonProps = {
  onFileSelect: (files: FileList) => void
  disabled?: boolean
  isUploading?: boolean
}

export const UploadAttachmentsButton: React.VFC<
  UploadAttachmentsButtonProps
> = ({ onFileSelect, disabled = false, isUploading = false }) => {
  const handleFileInputChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    const files = event.target.files
    if (!files || files.length === 0) return
    onFileSelect(files)
    event.target.value = ''
  }

  return (
    <div className="relative">
      <input
        type="file"
        multiple
        onChange={handleFileInputChange}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed"
        disabled={disabled}
        accept={ALLOWED_TYPES.join(',')}
      />
      <Button
        variant="outline"
        disabled={disabled || isUploading}
        className="whitespace-nowrap flex items-center gap-2"
      >
        {isUploading && (
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
        )}
        {isUploading ? 'Uploading...' : 'Upload attachments'}
      </Button>
    </div>
  )
}
